import React from "react";
import { motion } from "framer-motion";
import { Check, Video, Award } from "lucide-react";
import { IMAGES } from "../lib/api";
import { Seo } from "../components/site/Seo";
import { Reveal } from "../components/site/Reveal";
import { ServiceHero, SectionHeading, CheckList } from "../components/site/ServiceHero";
import { CTABand } from "../components/site/CTABand";
import { LeadForm } from "../components/site/LeadForm";
import { TRAINING_WEEKS, TRAINING_INCLUDES } from "../data/content";

export default function DispatchClass() {
  return (
    <div data-testid="training-page">
      <Seo title="Dispatch Training — Live 2-Week Hands-On Class" description="Learn freight dispatching through live, hands-on training — not just videos. 2-week dispatch training for $300: load boards, rate negotiation, broker communication, and building your logistics business." />
      <ServiceHero eyebrow="Dispatch Training" title="BUILD YOUR FREIGHT &" highlight="LOGISTICS BUSINESS."
        subtitle="Learn dispatching through hands-on training — not just videos. You learn how the work is actually done."
        image={IMAGES.dispatchMan} price="2-WEEK DISPATCH TRAINING — $300" />

      {/* Timeline */}
      <section className="relative py-20 overflow-hidden">
        <div className="max-w-5xl mx-auto px-4 sm:px-6">
          <SectionHeading eyebrow="The syllabus" center className="mb-14">A TWO-WEEK <span className="nm-gold-text">ROADMAP.</span></SectionHeading>
          <div className="relative grid md:grid-cols-2 gap-8">
            {TRAINING_WEEKS.map((w, i) => (
              <Reveal key={w.week} delay={i * 0.15}>
                <motion.div whileHover={{ y: -6 }} className="nm-card rounded-2xl p-8 relative overflow-hidden" data-testid={`week-${i}`}>
                  <span className="font-display text-7xl text-[#D4AF37]/15 absolute top-4 right-5">0{i + 1}</span>
                  <div className="w-12 h-12 rounded-xl bg-[#2563EB]/15 flex items-center justify-center mb-5">
                    <Video className="text-[#3B82F6]" size={22} />
                  </div>
                  <p className="font-mono text-xs tracking-[0.3em] text-[#D4AF37] mb-2">{w.week}</p>
                  <h3 className="font-head text-xl font-bold text-white">{w.title}</h3>
                </motion.div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Includes */}
      <section className="relative py-20 bg-[#0B132B]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 items-start">
          <div>
            <SectionHeading eyebrow="What you'll learn" className="mb-8">TRAINING INCLUDES</SectionHeading>
            <CheckList items={TRAINING_INCLUDES} />
            <Reveal>
              <div className="mt-8 nm-card rounded-xl p-6 flex items-center gap-4">
                <Award className="text-[#D4AF37]" size={26} />
                <p className="text-gray-200 text-sm">Finish with a <span className="font-bold text-white">final assessment</span> and a <span className="font-bold text-white">Certificate of Completion.</span></p>
              </div>
            </Reveal>
          </div>
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <div className="nm-card rounded-2xl p-6 border-l-4 border-[#10B981] mb-6">
                <p className="font-head text-xl font-bold text-white">THIS ISN'T JUST A CLASS WHERE YOU WATCH VIDEOS.</p>
                <p className="nm-gold-text font-head text-lg font-bold mt-1">YOU LEARN HOW THE WORK IS ACTUALLY DONE.</p>
              </div>
            </Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] mb-4">Enroll now — $300</p>
            <LeadForm source="training" defaultService="Dispatch Training" compact submitLabel="ENROLL NOW — $300" />
          </div>
        </div>
      </section>

      <CTABand eyebrow="Ready to learn dispatching? Enroll today." title="Learn the work. Build the business." button="ENROLL NOW — $300" />
    </div>
  );
}
